import React, { useEffect, useState } from "react";
import GenericCrudPage from "../common/GenericCrudPage";
import {
  getQuestionCategories,
  createQuestionCategory,
  updateQuestionCategory,
  deleteQuestionCategory,
} from "../../../services/QuestionCategoryService";
import { getSubjects } from "../../../services/SubjectService";
import { useTranslation } from "react-i18next";

const QuestionCategories = () => {
  const { t } = useTranslation();
  const [subjects, setSubjects] = useState([]);

  useEffect(() => {
    getSubjects({ page: 1, limit: 200 }).then((res) => setSubjects(res.data?.data || [])).catch(() => {});
  }, []);

  const subjectLabel = (id) => subjects.find((s) => s.id === id)?.name || "-";

  return (
    <GenericCrudPage
      permissionModule="QUESTION_CATEGORY"
      title={t("pages.questionCategories.title")}
      breadcrumbLabel={t("pages.questionCategories.breadcrumb")}
      addLabel={t("pages.questionCategories.addLabel")}
      searchPlaceholder={t("common.ui.rechercherCodeNom")}
      defaultSort={{ by: "name", dir: "asc" }}
      api={{
        list: getQuestionCategories,
        create: createQuestionCategory,
        update: updateQuestionCategory,
        remove: deleteQuestionCategory,
      }}
      filters={[{ key: "subject_id", label: t("common.fields.allSubjects"), options: subjects.map((s) => ({ value: s.id, label: s.name })) }]}
      columns={[
        { key: "code", label: t("common.fields.code"), sortable: true },
        { key: "name", label: t("common.fields.name"), sortable: true },
        { key: "subject_id", label: t("common.fields.subject"), render: (row) => subjectLabel(row.subject_id) },
        { key: "description", label: t("common.fields.description"), render: (row) => row.description || "-" },
      ]}
      fields={[
        { key: "subject_id", label: t("common.fields.subject"), type: "select", required: true, options: subjects.map((s) => ({ value: s.id, label: s.name })) },
        { key: "code", label: t("common.fields.code"), type: "text", required: true, placeholder: "ALGEBRE", maxLength: 30 },
        { key: "name", label: t("common.fields.name"), type: "text", required: true, placeholder: t("pages.questionCategories.algebreLineaire"), maxLength: 150 },
        { key: "description", label: t("common.fields.description"), type: "textarea" },
        { key: "is_active", label: t("common.crud.statusActive"), type: "checkbox" },
      ]}
      buildPayload={(formData) => ({
        subject_id: formData.subject_id,
        code: formData.code.trim(),
        name: formData.name.trim(),
        description: formData.description?.trim() || null,
        is_active: formData.is_active !== undefined ? !!formData.is_active : true,
      })}
      getItemLabel={(item) => item.name}
    />
  );
};

export default QuestionCategories;
